angular.module('ui.home',
    [
        'ui.omStat'
    ])

    .config(function ($stateProvider, $urlRouterProvider, customTemplateResolverProvider) {

        $urlRouterProvider.when('/client', '/client/home');

        $stateProvider.state('client.home', {
            url: '/home',
            template: customTemplateResolverProvider.get('home.html', 'app/ui/home/home.html'),
            controller: 'HomeController',

            data: {pageTitle: 'OrderManager: Home'}
        });
    })

    .controller('HomeController', function HomeController($q, $log, $timeout, $rootScope, $scope, $state, toastr, gettextCatalog, customResourceResolver,
                                                          $customisationConfig, usersRepository, workflowRepository, orderItemsRepository, 
                                                          barcodeScannerListenerService, orderItemsGridSharedSettings, gridDataProvider,
                                                          permissions, homeControllerUpdatesService, uiLocalization) {
        var defaultColor = "grey";

        if (angular.isUndefined($rootScope.orderStates)) $rootScope.orderStates = [];
        if (angular.isUndefined($rootScope.customOrderStates)) $rootScope.customOrderStates = [];
        if (angular.isUndefined($rootScope.allOpenOrdersCount)) $rootScope.allOpenOrdersCount = 0;

        //Save references on the local scope, so we can show the same values in our view
        $scope.orderStates = $rootScope.orderStates;
        $scope.customOrderStates = $rootScope.customOrderStates;
        $scope.allOpenOrdersCount = $rootScope.allOpenOrdersCount;

        $scope.isBusy = true;
        
        //Subscribe to barcode scanner events
        var barcodeScannerUnsubscribe = barcodeScannerListenerService.events.on('valueScanned', checkBarcode);

        var lazyInitData = _.debounceLimited(initData, 2000, 5000);

        initData();
        initSignalREvents();

        $scope.$on("$destroy", function () {
            // Commented the code to unsubscribe so we will keep the handlers working even when we left the Home view to refresh
            // orderStates statistics data used from $rootScope on other views.
            // TODO: We probably might want to refactor that into separate service supplying 'orderStates' data to Home view and other views
            //
            //homeControllerUpdatesService.onOrderItemChanged(void 0);
            //homeControllerUpdatesService.onNewOrderItem(void 0);
            //homeControllerUpdatesService.onOrderChanged(void 0);

            barcodeScannerUnsubscribe();
        });

        function initSignalREvents() {
            homeControllerUpdatesService.onOrderItemChanged(function () {
                lazyInitData();
            });
            homeControllerUpdatesService.onNewOrderItem(function () {
                lazyInitData();
            });

            homeControllerUpdatesService.onOrderChanged(function () {
                lazyInitData();
            });
        }

        var initDataPromise;

        function initData() {

            if (initDataPromise) {
                return initDataPromise
                    .then(function () {
                        return initData();
                    }, function () {
                        return initData();
                    });
            }

            initDataPromise = $q.all([
                usersRepository.getCurrentUser(),
                workflowRepository.getSteps(),
                workflowRepository.getStepStatistics(),
                customResourceResolver.resolveWorkflow(),
                customResourceResolver.resolveConfig('om-stat-custom-order-states', [], {})
            ])
                .then(function (data) {
                    var restUser = data[0];
                    var steps = data[1];
                    var stepsStat = data[2];
                    var workflowConfig = data[3];
                    var customOrderStatesConfig = data[4];

                    //Merge steps statistics data from server with the configuration/customisation data
                    var stepsConfig = workflowConfig.steps;
                    var promises = [];
                    var orderStates = [];
                    var customOrderStates = [];
                    var allOpenOrdersCount = 0;

                    _.forEach(steps, function (stepModel, stepIndex) {
                        var step = stepModel.$model;

                        promises.push(permissions.isStepTransitionAllowed(step.id)
                            .then(function (isAllowed) {
                                var stepConfig = _.find(stepsConfig, function (s) {
                                    return s.code == step.code;
                                });
                                var stepStat = _.find(stepsStat, function (ss) {
                                    return ss.step == step.code;
                                });
                                var stepStatisticValue = angular.isDefined(stepStat) ? stepStat.numOrderItems : 0;

                                //Skip the 'ignored' in the workflow configuration steps and don't even count items on that step
                                if (stepConfig && stepConfig.ignore === true) {
                                    return;
                                }
                                //Skip the 'hidden' step in terms of counting items and do not show it's button on home view
                                //However as this step is just hidden but not ignored - its items will be searchable during search
                                if (stepConfig && stepConfig.hide === true) {
                                    return;
                                }

                                //Count items (to show stats on 'All orders' button, but skip step-button creation if user
                                //has no rights to view the step or its action(s) of that step.
                                allOpenOrdersCount += stepStatisticValue;
                                if (!isAllowed) {
                                    return;
                                }

                                var isCustomer = restUser.isCustomer();
                                var noIcon = angular.isDefined(stepConfig) && !!stepConfig.noImageOnHomeView;

                                var fallbackIconForStep = function (stepCode) {
                                    return $customisationConfig.hasResource(function (res) { return _.string.contains(res, stepCode + "."); }) ? stepCode : "workflow";
                                };

                                //Info: We do localise step names using server-side localisation.
                                //This is achieved via 'sTranslate' angular filter inside the 'home view' html templates
                                orderStates.push({
                                    code: step.code,
                                    arrowDown: angular.isDefined(stepConfig) && angular.isDefined(stepConfig.arrowDown)
                                        ? stepConfig.arrowDown
                                        : false,
                                    arrowUp: angular.isDefined(stepConfig) && angular.isDefined(stepConfig.arrowUp)
                                        ? stepConfig.arrowUp
                                        : false,
                                    fork: angular.isDefined(stepConfig) && angular.isDefined(stepConfig.fork)
                                        ? stepConfig.fork
                                        : false,
                                    forked: angular.isDefined(stepConfig) && angular.isDefined(stepConfig.forked)
                                        ? stepConfig.forked
                                        : false,
                                    forksJoin: angular.isDefined(stepConfig) && angular.isDefined(stepConfig.forksJoin)
                                        ? stepConfig.forksJoin
                                        : false,
                                    afterJoin: angular.isDefined(stepConfig) && angular.isDefined(stepConfig.afterJoin)
                                        ? stepConfig.afterJoin
                                        : false,
                                    name: isCustomer ? step.publicNameResource : step.nameResource,
                                    statInfo: stepStatisticValue,
                                    color: angular.isDefined(stepConfig) && angular.isDefined(stepConfig.color)
                                        ? stepConfig.color
                                        : defaultColor,
                                    isFloating: angular.isDefined(stepConfig) &&
                                        angular.isDefined(stepConfig.isFloating)
                                        ? stepConfig.isFloating
                                        : false,
                                    uiPriority: angular.isDefined(stepConfig) &&
                                        angular.isDefined(stepConfig.uiPriority)
                                        ? stepConfig.uiPriority
                                        : Infinity,
                                    iconName: !noIcon
                                        ? (angular.isUndefined(stepConfig)
                                            ? fallbackIconForStep(step.code) : (angular.isDefined(stepConfig.publicImageResourceName) && isCustomer
                                                ? stepConfig.publicImageResourceName : (angular.isDefined(stepConfig.imageResourceName)
                                                    ? stepConfig.imageResourceName : fallbackIconForStep(step.code)))) : ""
                                });
                            }));
                    });

                    //See if we have configured in config custom order states queries to show on the Home view stats area
                    //in addition to the OM existing workflow steps
                    if (customOrderStatesConfig && customOrderStatesConfig.length > 0) {
                        _.forEach(customOrderStatesConfig, function (customOrderStateConfig, customOrderStateConfigIndex) {

                            if (customOrderStateConfig.queryForStatInfo) {

                                // Commented out for the time being as the query seems to be VERY HIGHLOAD for the server when called constantly
                                // we need to find another solution or a faster query for stats
                                //
                                //var getStatResultFromQueryPromise = orderItemsRepository.searchCount({ where: customOrderStateConfig.queryForStatInfo })
                                //    .then(function (customOrderStateQueryResult) {
                                //        //Save stat info onto custom order state config and use it for UI
                                //        customOrderStateConfig.statInfo = customOrderStateQueryResult;
                                //        customOrderStates.push(customOrderStateConfig);

                                //        $log.debug(_.str.sprintf('Custom stat [%s] query: %s', customOrderStateQueryResult, customOrderStateConfig.queryForStatInfo));
                                //    });

                                //Instead let's just create a simple promise and then put the custom button config into customOrderStates collection
                                var getStatResultFromQueryPromise = $q.when(true).then(function() {
                                        customOrderStateConfig.statInfo = '';
                                        customOrderStates.push(customOrderStateConfig);

                                        $log.debug(_.str.sprintf('IGNORED custom stat query: %s', customOrderStateConfig.queryForStatInfo));
                                });

                                promises.push(getStatResultFromQueryPromise);
                            }
                        });
                    }

                    return $q.all(promises)
                        .then(function () {
                            initDataPromise = null;
                            
                            //Update data shown to user
                            setOrUpdateObjectsCollection($rootScope.orderStates, orderStates, function (s1, s2) { return s1.code === s2.code; });
                            setOrUpdateObjectsCollection($rootScope.customOrderStates, customOrderStates, function (s1, s2) { return s1.code === s2.code; });
                            
                            $scope.allOpenOrdersCount = allOpenOrdersCount;
                            $rootScope.allOpenOrdersCount = allOpenOrdersCount;
                            $scope.isBusy = false;
                        });
                })
                .catch(function (resp) {
                    initDataPromise = null;
                    if (resp && resp.status) {
                        toastr.error(uiLocalization.translate("Data request failed. Error %s : %s", resp.status, resp.statusText));
                    } else {
                        toastr.error(gettextCatalog.getString("Data request failed"), gettextCatalog.getString("Server is not responding"));
                    }
                });

            return initDataPromise;
        }

        function setOrUpdateObjectsCollection(arrExistingData, arrNewData, matcher) {
            if (!arrExistingData || (arrNewData && arrExistingData.length !== arrNewData.length)) {
                //Completely new data, so assign the new data from collection with new data to the specified collection with existing data
                arrExistingData.splice(0, arrExistingData.length, ...arrNewData);
            } else {
                //Otherwise merge data so the numbers will be updated, not redrawn
                arrExistingData.forEach(function (o, index) {
                    var found = _.find(arrNewData, function(o2) { return matcher(o, o2); });
                    if (found) {
                        //Update existing object values
                        Object.assign(o, found);
                    } else {
                        //If not found - element was removed, so delete it
                        arrExistingData.splice(index, 1);
                    }
                });
            }
        }

        /**
         * Handle barcode scanner value scanned
         */
        function checkBarcode(e) {
            //See if the scanned value corresponds to any valid order item Id of any item on the currently 
            //being shown step, then select that item and redirect to the 'detailed' view
            if (e.value.length > 0) {
                //See if we have such an item in OrderManager
                findItem(e.value)
                    .then(function (found) {
                        if (found && found.items && found.items.length === 1) {
                            //If it does exist, redirect user to the items list filtering it to show 
                            //this exact item and making it a selected one to bring up into view
                            orderItemsGridSharedSettings.setSelectedOrderItemId(found.items[0].getId());
                            $state.go('client.step', {step: $scope.step});
                            orderItemsGridSharedSettings.setTextSearch(e.value, false); //switch off 'exact match'
                        } else {
                            //Nothing found so just reset search and refresh grid
                            var snd = new Audio("data:audio/wav;base64,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");
                            snd.play();
                            toastr.warning(gettextCatalog.getString('There are no items corresponding to the scanned barcode [' + e.value + '].'), gettextCatalog.getString('Nothing found :('));
                            orderItemsGridSharedSettings.setTextSearch('', false);
                        }
                    });
            }
        }

        function findItem(value) {
            if (value) {
                orderItemsGridSharedSettings.setStepFilter('all-open');
                orderItemsGridSharedSettings.setTextSearch(value, true); //setting 'exact match'

                return gridDataProvider.getData();
            }

            return $q.when(null);
        }
    })

    // Separate service for update events (to prevent multiple event subscription)
    .service('homeControllerUpdatesService', function (rest) {
        var _this = this;
        var newOrderItemCb;
        var orderItemChangedCb;
        var orderChangedCb;

        rest.events.on("modelCreatedOnServer", function (modelInfo) {
            if (!newOrderItemCb) {
                return;
            }
            if (modelInfo && modelInfo.modelType === "OrderItemModel") {
                newOrderItemCb(modelInfo);
            }
        });

        rest.events.on("modelUpdatedOnServer", function (modelInfo) {
            if (modelInfo.modelType === "OrderItemModel" && orderItemChangedCb) {
                orderItemChangedCb(modelInfo);
            } else if (modelInfo.modelType === "OrderModel" && orderChangedCb) {
                orderChangedCb(modelInfo);
            }
        });

        _this.onNewOrderItem = function (cb) {
            newOrderItemCb = cb;
        };

        _this.onOrderItemChanged = function (cb) {
            orderItemChangedCb = cb;
        };

        _this.onOrderChanged = function (cb) {
            orderChangedCb = cb;
        };

        return _this;
    })

;
